var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.formClass }, [
    _c("label", { staticClass: "control-label col-md-3" }, [
      _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-9" },
      [
        _c("vue-ckeditor", {
          ref: "ckeditor",
          attrs: { value: _vm.value, config: _vm.config },
          on: {
            input: function($event) {
              return _vm.updateValue($event)
            }
          }
        }),
        _vm._v(" "),
        _vm.hasError
          ? _c("span", { staticClass: "help-block" }, [
              _c("p", [_vm._v(" " + _vm._s(_vm.errorText) + " ")])
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-732a23a8", { render: render, staticRenderFns: staticRenderFns })
  }
}